export enum BankQuestionType {
    multiple = 'MULTIPLE',
    relation = 'RELATION',
    survey = 'SURVEY',
};


export type BankQuestionData = {
    id: string;
    index: number;
    text: string;
    type: BankQuestionType;
    options: QuestionOptionData[]
}

export type BankData = {
    name: string;
    description: string;
    questions: BankQuestionData[];
}

export type QuestionOptionData = {
    index: number;
    text: string;
    explanation?: string;
    correct?: boolean; // Only for multiple choice questions
}


export type FieldError = {
    data?: string;
    column: string;
    row: number;
    errorCode: string;
};

export type QuestionsValidationResponse = {
    count: number,
    questions: BankQuestionData[],
    errors: FieldError[]
}

export type BankCardData = {
    id: string,
    name: string,
    description: string,
    questionTypes: BankQuestionType[],
    questionCount: number,
    updatedAt: string
    coursesInUse: {
        id: string,
        name: string,
    }[]
}